export enum OverlayTypes {
    AreaSwitcherOverlay,
    None,
}

export type OverlayTypeSetterFunc = (type: OverlayTypes) => void;
